import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-validation-errors-message',
    templateUrl: './validation-errors-message.component.html',
    styles: [
        `
          :host {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding-right: 0;
          }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DhValidationErrorsMessageComponent implements OnInit, OnChanges {
    @Input() errors: {};
    @Input() validations: any[] = [];
    errorForView = '';
    validationParam;
    multifieldName;

    errorMessages = {
        CommaPresence: {
            key: 'message.validation_error.commaPresence'
        },
        MinLengthIntegerPartInDecimal: {
            key: 'message.validation_error.minLengthIntegerPartInDecimal',
            getParams: () => ({ length: this.validationParam })
        },
        NumberOfDigitsAfterPrecision: {
            key: 'message.validation_error.numberOfDigitsAfterPrecision',
            getParams: () => ({ length: this.validationParam })
        },
        MaxLength: {
            key: 'message.validation_error.maxLength',
            getParams: () => ({ length: this.validationParam })
        },
        ExactLength: {
            key: 'message.validation_error.exactLength',
            getParams: () => ({ length: this.validationParam })
        },
        MandatoryField: {
            key: 'message.validation_error.mandatoryField'
        },
        StartsWith: {
            key: 'message.validation_error.startsWith',
            getParams: () => ({ value: this.validationParam })
        },
        MustNotStartWith: {
            key: 'message.validation_error.mustNotStartWith',
            getParams: () => ({ value: this.validationParam })
        },
        MustNotEndWith: {
            key: 'message.validation_error.mustNotEndWith',
            getParams: () => ({ value: this.validationParam })
        },
        CharNotAllowed: {
            key: 'message.validation_error.charNotAllowed',
            getParams: () => ({ value: this.validationParam })
        },
        ValuesNotAllowed: {
            key: 'message.validation_error.valuesNotAllowed',
            getParams: () => ({ value: this.validationParam })
        },
        BICLength: {
            key: 'message.validation_error.bic_length',
            getParams: () => ({ value: this.validationParam })
        },
        MultiFieldMaxLength: {
            key: 'message.validation_error.multiFieldMaxLength',
            getParams: () => ({ field: this.multifieldName, length: this.validationParam })
        },
        MultiFieldExactLength: {
            key: 'message.validation_error.multiFieldExactLength',
            getParams: () => ({ field: this.multifieldName, length: this.validationParam })
        },
        drillDownValueDoesNotExist: {
            key: 'message.validation_error.drill_down_value_does_not_exist'
        },
        drillDownMultiValues: {
            key: 'message.validation_error.drill_down_multi_values'
        },
        drillDownReciverError: {
            key: 'message.validation_error.drill_down_reciver_error'
        },
        InvalidCurrency: {
            key: 'message.validation_error.invalid_currency'
        },
        CharecterNotAllowed: {
            key: 'message.validation_error.charecter_not_allowed'
        },
        DigitsOnly: {
            key: 'message.validation_error.digits_only'
        },
        InStaticList: {
            key: 'message.validation_error.in_static_list'
        },
        MultiFieldInStaticList: {
            key: 'message.validation_error.multi_field_in_static_list'
        },
        NonNegativeValue: {
            key: 'message.validation_error.non_negative_value'
        },
        allowedCharacters: {
            key: 'message.validation_error.allowedCharacters'
        },
        MaxNumber: {
            key: 'message.validation_error.maxNumber',
            getParams: () => ({ number: this.validationParam })
        },
        pattern: {
            key: 'message.validation_error.pattern_error'
        },
        passwordConfirming: {
            key: 'message.validation_error.password_confirming'
        },
        NccCodeLength: {
            key: 'message.validation_error.invalid_ncc_code_length',
            getParams: () => ({
                minLength: this.validationParam?.[0],
                maxLength: this.validationParam?.[1]
            })
        },
        IllegalIbanLength: {
            key: 'message.validation_error.illegalIbanLength'
        },
        CapitalLettersAndDigits: {
            key: 'message.validation_error.capitalLettersAndDigits'
        },
        CapitalLettersForIsoCountryCode: {
            key: 'message.validation_error.capitalLettersForIsoCountryCode'
        },
        Chars3and4MustBeDigits: {
            key: 'message.validation_error.chars3and4MustBeDigits'
        },
        InvalidIsoCountryCode: {
            key: 'message.validation_error.invalidIsoCountryCode'
        },
        LengthNotDefinedForCountryCode: {
            key: 'message.validation_error.lengthNotDefinedForCountryCode'
        },
        LengthDiffThenRequiredForCountryCode: {
            key: 'message.validation_error.lengthDiffThenRequiredForCountryCode'
        },
        InvalidIbanCheckDigitFailed: {
            key: 'message.validation_error.invalidIbanCheckDigitFailed'
        }
    };

    constructor() { }

    ngOnInit() {
        this.showFirstError(this.errors);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['errors'] != null) {
            this.showFirstError(changes['errors']['currentValue']);
        }
    }

    public showFirstError(errors: {}): void {
        if (errors !== null) {
            const errorsName = Object.keys(errors);
            const index = errorsName[0]?.includes('Verification') && errorsName[1] ? 1 : 0;
            const errorName = errorsName[index];
            this.errorForView = errorName;
            const firstError = {};
            firstError[errorName] = errors[errorName];
            this.getValidationParam(firstError, errorName);
        }
    }

    public showPaymentError(errors: {}): void {
        if (errors !== null) {
            this.errorForView = 'PaymentError';
            this.validations.forEach((validation, index) => {
                if (validation.name === this.errorForView) {
                    this.validationParam = validation.arguments;
                }
            });
        }
    }

    private getValidationParam(error: {}, errorName: string) {
        if (!this.validations) {
            return;
        }

        this.validations.forEach(
            validation => {
                if (validation.name === errorName) {
                    this.validationParam = validation.arguments;
                    //for multifields
                    if (error[errorName] != null && error[errorName] instanceof Array) {
                        this.multifieldName = error[errorName][1];
                    }
                }
            }
        );
    }
}
